import { Order } from "@/interfaces";
import { InvoiceComponent } from "@/screen/InvoiceComponent";
import apiService from "@/service";
import { createFileRoute, useRouter } from "@tanstack/react-router";


export const Route = createFileRoute('/(app)/(store)/sales/$orderId/')({
  loader: async ({ params }) => {
    const { data: order } = await apiService.get<Order>(
      "v1/order/" + params.orderId, {
      // "seller-product-detail": "true",
      "seller-store-detail": "true",
      "buyer-store-detail": "true",
      'buyer-detail': 'true',
      
    }
    );
    return order
  },
  component: RouteComponent
})

function RouteComponent() {
  const order = Route.useLoaderData()
    const router = useRouter();
  
    const handleOrderUpdated = () => {
      router.invalidate();
    };
    return <InvoiceComponent order={order} onOrderUpdated={handleOrderUpdated} />
}
